export default class MetricValueCalculationType {
    public static Value = 0;
    public static PercentageValue = 1;
    public static FractionValue = 2;
    public static PercentageCalculation = 3;
    public static Time = 4;
    public static Distance = 5;
    public static RateValue = 6;
}